module.exports = __webpack_public_path__ + "media/soundA.3fb2bc5e.mp3";